import script from "./BaseFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFilters.vue?vue&type=script&setup=true&lang=js"

import "./BaseFilters.vue?vue&type=style&index=0&id=7640aa9e&scoped=true&lang=scss"

import exportComponent from "/Users/river/dev/packages/plugin-openkaarten-frontend-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7640aa9e"]])

export default __exports__